module.exports = __webpack_public_path__ + "img/rocket_w.da467eef.svg";